import React from 'react'
import T from '../i18n/T'
import s from './FooterCocorico.less'
import frenchFlag from './french-flag.svg'

const FooterCocorico = () => {
  return (
    <div className={s.cocorico}>
      <div className={s.frenchFlag}>
        <img src={frenchFlag} alt="drapeau Français" width={16} height={16} />
      </div>
      <T id={'footer.cocorico'} />
    </div>
  )
}

export default FooterCocorico
